<template>
  <SimpleDataCard
      :title="'Toplam Teklif Satış Tutarı'"
      :data="numberConverter(reportCompanyData.totalOfferSale)"
      :description="'Tüm Zamanlar'"
      :loading="reportCompanyDataLoading"
  >

  </SimpleDataCard>
</template>

<script>

import SimpleDataCard from "@/components/dashboard/SimpleDataCard";
import {numberConverter} from "../../../../helpers";
import {mapState} from "vuex";

export default {
  name: "ToplamTeklifSatisTutari",
  components:{
    SimpleDataCard
  },
  computed: {
    ...mapState("dashboard",["reportCompanyData","reportCompanyDataLoading"])
  },
  methods:{
    numberConverter
  }
}
</script>

<style scoped>

</style>